import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ACTIVE_DIRECTORY } from '@app/shared/constants';
import { ActiveDirectorySettingsApiModel } from '@app/api/api-models/active-directory/ActiveDirectorySettingsApiModel';
import { ActiveDirectoryCheckUsernameApiModel } from '@app/api/api-models/active-directory/ActiveDirectoryCheckUsernameApiModel';
import { ActiveDirectoryLinkApiModel } from '@app/api/api-models/active-directory/ActiveDirectoryLinkApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class ActiveDirectoryService {
  public apiUrl = 'active-directory';

  constructor(private readonly http: HttpClientService) {}

  public checkActiveDirectory(model: ActiveDirectoryCheckUsernameApiModel): Observable<ActiveDirectoryLinkApiModel> {
    return this.http.post<ActiveDirectoryLinkApiModel>(`${this.apiUrl}/active-directory-link`, model);
  }

  public getActiveDirectorySettings(link: string): Observable<ActiveDirectorySettingsApiModel> {
    const cachedSettings = localStorage.getItem(ACTIVE_DIRECTORY.activeDirectorySettings);
    const settings = JSON.parse(cachedSettings) as ActiveDirectorySettingsApiModel;

    if (settings && (settings.Link === link || !link)) {
      return of(settings);
    }

    if (!link) {
      return throwError(null);
    }

    return this.http
      .get<ActiveDirectorySettingsApiModel>(`${this.apiUrl}/active-directory/${link}`)
      .pipe(
        tap((response) => localStorage.setItem(ACTIVE_DIRECTORY.activeDirectorySettings, JSON.stringify(response)))
      );
  }
}
